export default "__VITE_ASSET__CLj08cQL__"